/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as PreisvergleichRouteImport } from './routes/preisvergleich'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as IndexRouteImport } from './routes/index'

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const PreisvergleichRoute = PreisvergleichRouteImport.update({
  id: '/preisvergleich',
  path: '/preisvergleich',
  getParentRoute: () => rootRouteImport,
} as any)
const KontaktRoute = KontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/kontakt': typeof KontaktRoute
  '/preisvergleich': typeof PreisvergleichRoute
  '/test': typeof TestRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/kontakt': typeof KontaktRoute
  '/preisvergleich': typeof PreisvergleichRoute
  '/test': typeof TestRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/kontakt': typeof KontaktRoute
  '/preisvergleich': typeof PreisvergleichRoute
  '/test': typeof TestRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/datenschutz'
    | '/impressum'
    | '/kontakt'
    | '/preisvergleich'
    | '/test'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/datenschutz'
    | '/impressum'
    | '/kontakt'
    | '/preisvergleich'
    | '/test'
  id:
    | '__root__'
    | '/'
    | '/datenschutz'
    | '/impressum'
    | '/kontakt'
    | '/preisvergleich'
    | '/test'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DatenschutzRoute: typeof DatenschutzRoute
  ImpressumRoute: typeof ImpressumRoute
  KontaktRoute: typeof KontaktRoute
  PreisvergleichRoute: typeof PreisvergleichRoute
  TestRoute: typeof TestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preisvergleich': {
      id: '/preisvergleich'
      path: '/preisvergleich'
      fullPath: '/preisvergleich'
      preLoaderRoute: typeof PreisvergleichRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kontakt': {
      id: '/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof KontaktRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DatenschutzRoute: DatenschutzRoute,
  ImpressumRoute: ImpressumRoute,
  KontaktRoute: KontaktRoute,
  PreisvergleichRoute: PreisvergleichRoute,
  TestRoute: TestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
